import { Project } from '@bulthaup/api/db';
import { getProjectAmounts } from '@bulthaup/api/entities/budget';
import { sum } from '@bulthaup/api/utils';
import { Grid, Group, Paper, Stack, Text, Title } from '@mantine/core';

import { formatAmount } from '../../../../../utils/format';

export function ProjectDetails({ project }: { project: Project }) {
  const { gross } = getProjectAmounts(project);
  const totalGross = sum(Object.values(gross));

  return (
    <Stack gap="sm">
      <Group justify="space-between">
        <Title order={3} size="h4" c="dimmed">
          {project.name}
        </Title>
      </Group>

      {/* Totals Section */}
      <Paper p="sm" withBorder bg="gray.0">
        <Stack gap="xs">
          <Text fw={600} size="sm" c="dark">
            Totaux TTC
          </Text>

          <Grid gutter="xl">
            <Grid.Col span={12}>
              <Group justify="space-between">
                <Text size="xs">Meuble TVA 10% :</Text>
                <Text size="xs" fw={500}>
                  {formatAmount(gross.furniture10Percent)}
                </Text>
              </Group>
              <Group justify="space-between">
                <Text size="xs">Robinetterie TVA 10% :</Text>
                <Text size="xs" fw={500}>
                  {formatAmount(gross.faucets10Percent)}
                </Text>
              </Group>
              <Group justify="space-between">
                <Text size="xs">Livraison et Pose TVA 10% :</Text>
                <Text size="xs" fw={500}>
                  {formatAmount(gross.delivery10Percent)}
                </Text>
              </Group>
              <Group justify="space-between">
                <Text size="xs">Meuble :</Text>
                <Text size="xs" fw={500}>
                  {formatAmount(gross.furniture)}
                </Text>
              </Group>
              <Group justify="space-between">
                <Text size="xs">Électro :</Text>
                <Text size="xs" fw={500}>
                  {formatAmount(gross.appliance)}
                </Text>
              </Group>
              <Group justify="space-between">
                <Text size="xs">Robinetterie :</Text>
                <Text size="xs" fw={500}>
                  {formatAmount(gross.faucets)}
                </Text>
              </Group>
              <Group justify="space-between">
                <Text size="xs">Livraison et Pose :</Text>
                <Text size="xs" fw={500}>
                  {formatAmount(gross.delivery)}
                </Text>
              </Group>
              <Group justify="space-between">
                <Text size="xs">Honoraires Architecte :</Text>
                <Text size="xs" fw={500}>
                  {formatAmount(gross.architectFee)}
                </Text>
              </Group>
            </Grid.Col>
          </Grid>

          <Group
            justify="space-between"
            mt="xs"
            pt="xs"
            style={{ borderTop: '1px solid #e9ecef' }}
          >
            <Text size="sm" fw={600} c="dark">
              Total Projet TTC:
            </Text>
            <Text size="sm" fw={700} c="dark">
              {formatAmount(totalGross)}
            </Text>
          </Group>
        </Stack>
      </Paper>
    </Stack>
  );
}
